module.exports = __webpack_public_path__ + "static/img/woman2.7bd996c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HumanPic/woman2.png
// module id = 5pbZ
// module chunks = 2